
import { api } from "./axios";

export const assetsApi = {

    create: (artistId: string, formData: FormData) =>
        api.post(`/artists/create-assets/${artistId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            timeout: 60000,
        }),
    getByArtistId: (artistId: string, searchParams?: { title?: string; category?: string }) => {
        const url = `/artists/get-assets/${artistId}`;
        return api.get(url, { params: searchParams });
    },
    update: (artistId: string, index: number, imageTitle: string) =>
        api.put(`/artists/update-image-title/${artistId}/${index}`, { imageTitle: imageTitle }),
};
